"use client"

import { useState, useEffect } from "react"
import { useEffectAsync } from "../reactHelper"
import { useTranslation } from "../common/components/LocalizationProvider"
import { useAdministrator } from "../common/util/permissions"
import PageLayout from "../common/components/PageLayout"
import SettingsMenu from "./components/SettingsMenu"
import CollectionFab from "./components/CollectionFab"
import CollectionActions from "./components/CollectionActions"
import useSettingsStyles from "./common/useSettingsStyles"
import DataTable from "../common/components/Datatable"
import usePositionAttributes from "../common/attributes/usePositionAttributes"

const ComputedAttributesPage = () => {
  const { classes } = useSettingsStyles();
  const t = useTranslation()
  const positionAttributes = usePositionAttributes(t)

  const [timestamp, setTimestamp] = useState(Date.now())
  const [items, setItems] = useState([])
  const [loading, setLoading] = useState(false)
  const administrator = useAdministrator()


  useEffect(() => {
    // console.log("Position Attributes:", positionAttributes)
  }, [positionAttributes])

  useEffectAsync(async () => {
    setLoading(true)
    try {
      const response = await fetch("/api/attributes/computed")
      if (response.ok) {
        const data = await response.json()
        // console.log("Fetched items:", data) 
        setItems(data)
      } else {
        throw Error(await response.text())
      }
    } finally {
      setLoading(false)
    }
  }, [timestamp])

  const columns = [
    { field: "id", headerName: "ID", width: 80, disableColumnMenu: true },
    { field: "description", headerName: t("sharedDescription"), flex: 1, disableColumnMenu: true },
    {
      field: "attribute",
      headerName: t("sharedAttribute"),
      flex: 1,
      disableColumnMenu: true,
      renderCell: (params) => {
        if (!params || !params.row || !params.row.attribute) {
          return ""
        }

        const attributeKey = params.row.attribute
        // console.log("Rendering attribute:", attributeKey) // Debug log

        // Try to find the attribute in positionAttributes
        if (positionAttributes && positionAttributes[attributeKey] && positionAttributes[attributeKey].name) {
          console.log("Found translation:", positionAttributes[attributeKey].name) // Debug log
          return positionAttributes[attributeKey].name
        }

        // Try with position prefix (common pattern in your code)
        const keyWithPrefix = `position${attributeKey.charAt(0).toUpperCase()}${attributeKey.slice(1)}`
        if (positionAttributes && positionAttributes[keyWithPrefix] && positionAttributes[keyWithPrefix].name) {
          // console.log("Found translation with prefix:", positionAttributes[keyWithPrefix].name) // Debug log
          return positionAttributes[keyWithPrefix].name
        }

        // If no translation found, return the original attribute name with better formatting
        const formattedName = attributeKey.replace(/([A-Z])/g, " $1").replace(/^./, (str) => str.toUpperCase())

        // console.log("Using formatted name:", formattedName) // Debug log
        return formattedName
      },
    },
    { field: "expression", headerName: t("sharedExpression"), flex: 1, disableColumnMenu: true },
    { field: "type", headerName: t("sharedType"), flex: 1, disableColumnMenu: true },
    {
      field: "actions",
      headerName: t("actions"),
      sortable: false,
      renderCell: (params) => {
        if (!params || !params.row) return null

        return (
          <div>
            <CollectionActions
              itemId={params.row.id}
              editPath="/settings/attribute"
              endpoint="attributes/computed"
              setTimestamp={setTimestamp}
            />
          </div>
        )
      },
      width: 150,
      disableColumnMenu: true,
      hide: !administrator,
    },
  ]

  return (
    <PageLayout menu={<SettingsMenu />} breadcrumbs={["settingsTitle", "sharedComputedAttributes"]}>
      <DataTable tableName="computedAttributes" columns={columns} rows={items} loading={loading} />
      <CollectionFab editPath="/settings/attribute" disabled={!administrator} />
    </PageLayout>
  )
}

export default ComputedAttributesPage
